<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <b-field label="Test method">
        <b-select
          placeholder="Select the test method"
          expanded
          v-model="formTestMethod.testMethod"
          required
          @input="setDefaultValuesForConfig"
        >
          <option
            v-for="testMethod in testMethods"
            :value="testMethod"
            :key="testMethod.alias">
            {{ testMethod.name }}
          </option>
        </b-select>
      </b-field>
    </div>

    <div class="column is-6" v-for="testConfig in formTestMethod.testMethod.testConfig">
      <div class="field" v-if="testConfig.type==='json'">
        <label class="label">{{ testConfig.name }}</label>
        <v-jsoneditor v-model="formTestMethod.testMethodConfig[testConfig.key]" :plus="false" height="200px"
                      :options="jsonEditorOptions"/>
        <p class="help" v-if="testConfig.description">{{ testConfig.description }}</p>
      </div>

      <b-field :label="testConfig.name" v-else-if="testConfig.type==='select'" :message="testConfig.description">
        <b-select expanded v-model="formTestMethod.testMethodConfig[testConfig.key]" :required="testConfig.required">
          <option
            v-for="(value, key) in testConfig.options"
            :value="key"
            :key="key">
            {{ value }}
          </option>
        </b-select>
      </b-field>

      <b-field :label="testConfig.name" v-else :message="testConfig.description">
        <b-input
          v-model="formTestMethod.testMethodConfig[testConfig.key]"
          :required="testConfig.required">
        </b-input>
      </b-field>
    </div>


    <div class="column is-12">
      <b-message :title="'Example response'" v-if="formTestMethod.testMethod.exampleResponse">
        <pre>
          {{formTestMethod.testMethod.exampleResponse}}
        </pre>
      </b-message>
    </div>
  </div>
</template>

<script>

import TestMethodService from "@/services/TestMethodService";
import VJsoneditor from 'v-jsoneditor'

export default {
  name: 'TestMethod',
  data () {
    return {
      formTestMethod: {},
      testMethods: [],
      jsonEditorOptions: {
        mode: 'code',
        search: 'false',
        mainMenuBar: false,
        statusBar: false
      }
    }
  },

  components: {
    VJsoneditor
  },

  created() {
    this.getTestMethods();
    this.formTestMethod = this.$store.getters['testType/formTestMethod'];
  },

  methods: {
    getTestMethods() {
      TestMethodService.getList()
        .then(response => {
          this.testMethods = response.data
        })
    },

    setDefaultValuesForConfig() {
      if (this.formTestMethod.testMethod) {
        for (let config of this.formTestMethod.testMethod.testConfig) {
          this.formTestMethod.testMethodConfig[config.key] = config.defaultValue;
        }
      }
    }
  }
}
</script>
